import { shape } from 'prop-types';
import { withError } from 'utils/old-ui-commons/final-form-states';

import { Box, FieldError, Input } from '@olist/united';

const DecoratedInput = withError(Input);

const FormInput = ({ input, meta, ...props }) => {
  const hasErrorAndTouched = meta.error && meta.touched;
  const hasSubmitError = !meta.dirtySinceLastSubmit && meta.submitError;
  const errors = meta.error || meta.submitError;

  return (
    <>
      <DecoratedInput {...input} meta={meta} {...props} />
      {(hasErrorAndTouched || hasSubmitError) && (
        <Box mt={2}>
          <FieldError messages={errors} />
        </Box>
      )}
    </>
  );
};

FormInput.propTypes = {
  meta: shape({}).isRequired,
  input: shape({}).isRequired,
};

export default FormInput;
